<icc-external-menu-panel *ngIf="hasExternalMenu"></icc-external-menu-panel>
<div class="b2b" [ngClass]="{'b2b_configurator': activePanel === 'configurator'}" >
    <icc-header
        [userBoxData]="userBoxData"
        [activatedRouteRootChildren]="activatedRouteRootChildren"
        [themeLogo]="themeLogo"
        [themeSmallLogo]="themeSmallLogo"
        [activePanel]="activePanel"
        [hasExternalMenu]="hasExternalMenu"
        [condensedUserMenu]="condensedUserMenu"
    ></icc-header>
    <div class="container" [ngClass]="{'b2b_configurator_container': activePanel === 'configurator'}" id="container">
        <div id="top"></div>
        <router-outlet (activate)="activatedChild($event)" ></router-outlet>
        <icc-footer
            *ngIf="activePanel !== 'configurator' && activePanel !== 'complaint'"
        ></icc-footer>
    </div>
</div>